import { synUtil } from "../../../javascript/Utilities";
import { AjaxSolr } from "../core/Core.js";
import "../core/AbstractManager.js";

(function (callback) {
    if (typeof define === 'function' && define.amd) {
        define(['../core/AbstractManager.js'], callback);
    }
    else {
        callback();
    }
}(function () {

    /**
     * @see http://wiki.apache.org/solr/SolJSON#JSON_specific_parameters
     * @class Manager
     * @augments AjaxSolr.AbstractManager
     */
    AjaxSolr.Manager = AjaxSolr.AbstractManager.extend(
        /** @lends AjaxSolr.Manager.prototype */
        {
            constructor: function (attributes) {
                AjaxSolr.Manager.__super__.constructor.apply(this, arguments);
                AjaxSolr.extend(this, {
                    requireSearchText: true,
                    onMissingSearchConstraints: function () { }
                }, attributes);
            },
            // Returns q and fq parameters as array of key value pairs
            getSearchConstraints: function () {
                let constraints = [];
                let q = this.store.get("q").val();
                if (q && q !== "*:*")
                    constraints.push(["q", q]);

                let fq = this.store.values("fq");
                for (let i = 0, l = fq.length; i < l; i++) {
                    if (fq[i]) {
                        let text = "";
                        let spl = fq[i].replace(/\{!tag=[A-Za-z0-9_]+}/, "").split(":");
                        let internalField = spl[0];
                        if (this.isDateWidget(internalField)) {
                            let tmp = spl.slice(1).join(":");
                            spl[1] = tmp;
                            spl = spl.slice(0, 2);
                        }
                        constraints.push(spl);
                    }
                }
                return constraints;
            },
            executeRequest: function (servlet, string, handler, errorHandler) {
                let self = this,
                    options = {
                        headers: { "__RequestVerificationToken": synUtil.requestVerificationToken },
                        dataType: 'json'
                    };

                let doRequestCore = function (callBack) {
                    string = string || self.store.string();
                    handler = handler || function (data) {
                        self.handleResponse(data);
                    };
                    errorHandler = errorHandler || function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.responseJSON.error && jqXHR.responseJSON.error.msg === "403")
                            synUtil.logon();
                        else
                            self.handleError(jqXHR, textStatus, errorThrown);
                    };

                    // If query string becomes long, switch to POST
                    if (string.length > 1500) {
                        options.url = self.solrUrl + (servlet || '');
                        options.data = string + '&wt=json&json.wrf=?';
                        options.type = 'POST';
                    }
                    else {
                        options.url = self.solrUrl + (servlet || '') + (servlet ? '?' : '&') + string + '&wt=json&json.wrf=?';
                    }
                    jQuery.ajax(options)
                        .done(handler)
                        .fail(errorHandler)
                        .always(function () {
                            for (let widgetId in self.widgets) {
                                self.widgets[widgetId].cleanUp();
                            }
                            if (callBack)
                                callBack();
                        });
                };

                if (!self.getSearchConstraints().length) {
                    if (self.requireSearchText) {
                        self.onMissingSearchConstraints();
                    }
                    else {
                        let oldRowsVal = self.store.get("rows").val();
                        self.store.get("rows").val("0");
                        doRequestCore(function () {
                            self.store.get("rows").val(oldRowsVal);
                        });
                    }
                }
                else
                    doRequestCore();
            }
        });

}));
